// src/pages/PageAjouterEvenement.jsx

import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom'; // Utilisation de useNavigate au lieu de useHistory

const API_URL = process.env.REACT_APP_API_URL;
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
});

const PageAjouterEvenement = () => {
  const [dateSelectionnee, setDateSelectionnee] = useState(new Date());
  const [nouvelEvenement, setNouvelEvenement] = useState({
    titre: '',
    description: '',
    lien: '',
  });
  const [messageSuccess, setMessageSuccess] = useState(''); // Message de succès
  const navigate = useNavigate(); // Hook pour la redirection avec useNavigate

  // Fonction pour ajouter un événement
  const ajouterEvenement = async () => {
    if (!nouvelEvenement.titre || !nouvelEvenement.lien) {
      return; // Si les champs sont vides, ne pas envoyer
    }

    // Vérification de la validité de la date
    if (isNaN(dateSelectionnee.getTime())) {
      console.error("Date invalide");
      return;
    }

    // Ajuster la date pour éviter le décalage
    const dateCorrecte = new Date(dateSelectionnee);
    dateCorrecte.setHours(0, 0, 0, 0); // Réinitialiser l'heure à minuit pour éviter le décalage

    const payload = {
      date: dateCorrecte.toISOString().split('T')[0], // Format YYYY-MM-DD
      ...nouvelEvenement,
    };

    try {
      const res = await axiosInstance.post('/api/evenements', payload);
      console.log("Nouvel événement ajouté :", res.data);
      setMessageSuccess('Événement ajouté avec succès!');
      
      // Rediriger vers la page du calendrier après 2 secondes
      setTimeout(() => {
        navigate('/calendrier'); // Utilisation de navigate pour rediriger
      }, 2000);
    } catch (err) {
      console.error("Erreur lors de l'envoi :", err);
      setMessageSuccess('Une erreur est survenue, veuillez réessayer.');
    }
  };

  return (
    <div className="max-w-6xl mx-auto p-4">
      <h1 className="text-3xl font-bold mb-6 text-center">Ajouter un événement</h1>

      {/* Formulaire d'ajout d'événement */}
      <div className="bg-gray-100 p-4 rounded shadow mb-6">
        <h2 className="text-lg font-semibold mb-2">Détails de l'événement</h2>

        {/* Datepicker */}
        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">Date de l'événement</label>
          <DatePicker
            selected={dateSelectionnee}
            onChange={setDateSelectionnee}
            dateFormat="yyyy-MM-dd"
            className="block w-full p-2 mb-2 border rounded"
          />
        </div>

        {/* Titre */}
        <input
          type="text"
          placeholder="Titre"
          value={nouvelEvenement.titre}
          onChange={(e) => setNouvelEvenement({ ...nouvelEvenement, titre: e.target.value })}
          className="block w-full p-2 mb-2 border rounded"
        />

        {/* Description */}
        <textarea
          placeholder="Description"
          value={nouvelEvenement.description}
          onChange={(e) => setNouvelEvenement({ ...nouvelEvenement, description: e.target.value })}
          className="block w-full p-2 mb-2 border rounded"
        />

        {/* Lien */}
        <input
          type="url"
          placeholder="Lien"
          value={nouvelEvenement.lien}
          onChange={(e) => setNouvelEvenement({ ...nouvelEvenement, lien: e.target.value })}
          className="block w-full p-2 mb-2 border rounded"
        />

        {/* Bouton pour ajouter l'événement */}
        <button
          onClick={ajouterEvenement}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Ajouter
        </button>
      </div>

      {/* Message de succès ou d'erreur */}
      {messageSuccess && (
        <div className="mt-4 text-center text-green-600">
          {messageSuccess}
        </div>
      )}
    </div>
  );
};

export default PageAjouterEvenement;
